import classNames from 'classnames';
import React, { FC } from 'react';
import { t } from 'utils';

import styles from './FormError.module.scss';

export interface IFormError {
  text?: string;
}

const FormError: FC<IFormError> = (props) => {
  const { text } = props;

  return (
    <div className={styles.root}>
      <span className={classNames(styles.icon, 'fas fa-exclamation-triangle')}></span>
      <p className={styles.text}>{text ?? t('errors.loginError')}</p>
    </div>
  );
};

export default FormError;
